import tagsApi from '@/services/api/tagsApi';
import {
  baseActions, baseGetters, baseMutations, baseState,
} from '@/store/components/base';
import {
  sortActions, sortGetters, sortMutations, sortState,
} from '@/store/components/sort';
import {
  paginationActions, paginationGetters, paginationMutations, paginationState,
} from '@/store/components/pagination';
import { TAG_TYPES } from '@/commons/constants/tagTypes';

const initialState = () => ({
  ...baseState,
  ...sortState,
  ...paginationState,
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    ...baseActions,
    ...sortActions,
    ...paginationActions,
    async fetchItems({ commit }) {
      commit('setFetchProgress', true);
      try {
        const items = await tagsApi.fetchItems();
        commit('setItems', items);
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки тегов'], { root: true });
        return Promise.reject(err);
      } finally {
        commit('setFetchProgress', false);
      }
    },
  },
  mutations: {
    ...baseMutations,
    ...sortMutations,
    ...paginationMutations,
    clearState(state) {
      Object.entries(initialState()).forEach(([key, value]) => { state[key] = value; });
    },
  },
  getters: {
    ...baseGetters,
    ...sortGetters,
    ...paginationGetters,
    levelTags: (state, getters) => getters.items.filter((t) => t.type === TAG_TYPES.LEVEL),
    purposeTags: (state, getters) => getters.items.filter((t) => t.type === TAG_TYPES.PURPOSE),
    otherTags: (state, getters) => getters.items.filter((t) => t.type === TAG_TYPES.OTHER),
  },
};
